(() => {
  if (window.czU2Review) return;
  const root = document.querySelector('[data-u2-plan]');
  if (!root) return;
  const dialog = root.querySelector('[data-u2-dialog]');
  const review = root.querySelector('[data-u2-review]');
  let redirectTimer;
  let messageTimer;
  const cancelRedirect = () => { clearTimeout(redirectTimer); clearTimeout(messageTimer); };
  review.addEventListener('close', cancelRedirect);
  window.addEventListener('pagehide', cancelRedirect);
  root.querySelector('[data-u2-open]').addEventListener('click', () => dialog.showModal());
  for (const modal of [dialog, review]) {
    modal.querySelector('[data-u2-close]').addEventListener('click', () => modal.close());
    modal.addEventListener('click', event => { if (event.target === modal) { const box = modal.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) modal.close(); } });
  }
  function select(id) {
    const card = document.getElementById('cz-cat-' + id);
    if (!card) return;
    dialog.close();
    document.querySelectorAll('.cz-cat.cz-open').forEach(other => other.classList.remove('cz-open'));
    card.classList.add('cz-open');
    card.scrollIntoView({ block: 'center', behavior: 'instant' });
    card.querySelector('.cz-qty-btn')?.focus({ preventScroll: true });
  }
  for (const target of root.querySelectorAll('[data-u2-category]')) {
    target.addEventListener('click', () => select(target.dataset.u2Category));
    if (target.tagName.toLowerCase() === 'g') target.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); select(target.dataset.u2Category); } });
  }
  window.czU2Review = (url, id, quantity) => {
    const destination = new URL(url);
    if (destination.origin !== 'https://www.francepaiement.com' || !Number.isInteger(quantity) || quantity < 1 || quantity > 6) return;
    const card = document.getElementById('cz-cat-' + id);
    cancelRedirect();
    review.querySelector('[data-u2-progress-title]').textContent = 'Préparation de votre sélection…';
    review.querySelector('[data-u2-review-summary]').textContent = quantity + (quantity > 1 ? ' billets · ' : ' billet · ') + card.querySelector('.cz-cat-name').textContent.trim();
    review.showModal();
    messageTimer = setTimeout(() => { review.querySelector('[data-u2-progress-title]').textContent = 'Votre sélection est prête !'; }, 800);
    redirectTimer = setTimeout(() => { window.location.assign(destination.href); }, 1500);
  };
  window.czU2CartProgress = (phase, id, quantity, error) => {
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 6) return;
    cancelRedirect();
    const card = document.getElementById('cz-cat-' + id);
    review.querySelector('[data-u2-review-summary]').textContent = quantity + (quantity > 1 ? ' billets · ' : ' billet · ') + (card?.querySelector('.cz-cat-name')?.textContent.trim() || '');
    const title = review.querySelector('[data-u2-progress-title]');
    const caption = review.querySelector('.u2-progress-caption');
    review.dataset.phase = phase;
    if (!review.open) review.showModal();
    if (phase === 'loading') {
      title.textContent = 'Vérification de votre sélection…';
      caption.textContent = 'Ajout de vos billets au panier…';
    } else if (phase === 'success') {
      title.textContent = quantity + (quantity > 1 ? ' billets ajoutés à votre panier !' : ' billet ajouté à votre panier !');
      caption.textContent = 'Ouverture de votre panier…';
      // Le sélecteur gère la navigation après l'ajout, indépendamment de ce dialogue.
    } else {
      title.textContent = 'Ajout au panier impossible';
      caption.textContent = error || 'Veuillez réessayer.';
    }
  };
})();
